import React, { ReactNode } from 'react';
import { Box, EmptyState, EmptyStateProps } from '@wix/design-system';
import { observer } from 'mobx-react-lite';

export interface EmptyStateBaseProps
  extends EmptyStateBasePrivateProps,
    Omit<Partial<EmptyStateProps>, 'title' | 'subtitle' | 'image'> {
  children?: ReactNode;
  /**
   * Hides all default CTA buttons such as "Reset Filters" / "New Item"
   * @external
   */
  disableDefaultCta?: boolean;
  /**
   * Adds more custom CTA buttons
   * @external
   */
  customCta?: ReactNode;
}

export interface EmptyStateBasePrivateProps {
  title: string;
  subtitle: string;
  cta?: ReactNode;
  image?: string | ReactNode;
}

function _EmptyStateBase(props: EmptyStateBaseProps) {
  const { children, customCta, title, subtitle, cta, image, ...rest } = props;

  let child;

  if (cta || customCta) {
    child = (
      <Box gap="SP5">
        {cta}
        {customCta}
      </Box>
    );
  }

  if (children) {
    child = (
      <>
        {child}
        {children}
      </>
    );
  }

  return (
    <EmptyState
      title={title}
      subtitle={subtitle}
      theme="page-no-border"
      image={image ? <div style={{ display: 'flex' }}>{image}</div> : undefined}
      {...rest}
    >
      {child}
    </EmptyState>
  );
}

export const EmptyStateBase = observer(_EmptyStateBase);
